import script from "./formInput.vue?vue&type=script&setup=true&lang=js"
export * from "./formInput.vue?vue&type=script&setup=true&lang=js"

import "./formInput.vue?vue&type=style&index=0&id=13790b0d&lang=scss"

const __exports__ = script;

export default __exports__